import { ampli, type Ampli } from 'lib-shared-tracking';
import { useEffect } from 'react';

import { useAppDispatch } from 'utils/redux/useAppDispatch';

const intelligenceTrackingEventNames = [
  'intelligenceDistributionChartOpened',
  'intelligenceEvolutionChartOpened',
  'intelligenceFilterChanged',
  'intelligenceFilterPeriodChanged',
  'intelligenceGroupByChanged',
  'intelligencePresetComparisonStarted',
  'intelligenceTableCustomized',
] satisfies Array<keyof Ampli>;

export type IntelligenceTrackingEvents =
  (typeof intelligenceTrackingEventNames)[number];

export const useIntelligenceTrackingEvents = (): void => {
  const dispatch = useAppDispatch();

  useEffect(() => {
    if (typeof window === 'undefined') return;
    const { ampliEvents } = window._intelligence;

    ampliEvents.on('intelligenceDistributionChartOpened', (properties) =>
      ampli.intelligenceDistributionChartOpened(properties),
    );

    ampliEvents.on('intelligenceEvolutionChartOpened', (properties) =>
      ampli.intelligenceEvolutionChartOpened(properties),
    );

    ampliEvents.on('intelligenceFilterChanged', (properties) =>
      ampli.intelligenceFilterChanged(properties),
    );

    ampliEvents.on('intelligenceFilterPeriodChanged', (properties) =>
      ampli.intelligenceFilterPeriodChanged(properties),
    );

    ampliEvents.on('intelligenceGroupByChanged', (properties) =>
      ampli.intelligenceGroupByChanged(properties),
    );

    ampliEvents.on('intelligencePresetComparisonStarted', (properties) =>
      ampli.intelligencePresetComparisonStarted(properties),
    );

    ampliEvents.on('intelligenceTableCustomized', (properties) =>
      ampli.intelligenceTableCustomized(properties),
    );
  }, [dispatch]);
};
